export const tShirtSizes = [
  'extra-small',
  'small',
  'medium',
  'large',
  'extra-large'
] as const
export type TShirtSize = typeof tShirtSizes[number]

export interface SizeBrand {
  readonly size: unique symbol
}
export type Size = number & SizeBrand

export const tShirtSizeToSize = (tShirtSize: TShirtSize): Size =>
  tShirtSizes.indexOf(tShirtSize) as Size

export const atLeast = (threshold: TShirtSize) => (size: TShirtSize): boolean =>
  tShirtSizeToSize(size) >= tShirtSizeToSize(threshold)
